import { render, staticRenderFns } from "./ConfirmacionEliminar.vue?vue&type=template&id=0f5da944&scoped=true&"
import script from "./ConfirmacionEliminar.vue?vue&type=script&lang=js&"
export * from "./ConfirmacionEliminar.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmacionEliminar.vue?vue&type=style&index=0&id=0f5da944&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5da944",
  null
  
)

export default component.exports